import { Reducer } from "redux";
import { ApplicationState } from "store";

export interface ResourceState {
    [key: string]: string | undefined;
}

export const initialState = {};

interface ResourceConfig {
    key: string;
    defaultValue?: string;
}

export const getResource = (
    { resource }: ApplicationState,
    { key, defaultValue }: ResourceConfig,
): string => resource[key] || defaultValue || `NO RESOURCE WITH KEY '${key}'`;

export const reducer: Reducer<Object> = (state: Object = initialState) => {
    // todo, add actions etc
    return state;
};
